import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css';
import { ReactComponent as EtyLogo } from './etyLogo.svg';
import { ReactComponent as SignIn } from './signIn.svg';
import './Dialog.css';
import ApiService from './ApiService';

const LoginPage = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [language, setLanguage] = useState('en');
    const [error, setError] = useState('');
    const [showVerificationDialog, setShowVerificationDialog] = useState(false);
    const [verificationKey, setVerificationKey] = useState('');
    const [verificationError, setVerificationError] = useState('');
    const [isVerifying, setIsVerifying] = useState(false);
    const navigate = useNavigate();

  

  
    const checkVerification = async () => {
        try {
            const accountData = await ApiService.getSelf();
            if (!accountData.data.verified) {
                setShowVerificationDialog(true);
            } else {
                navigate('/upload');
            }
        } catch (error) {
            console.error('Verification check failed:', error);
            setError(handleErrorResponse(error));
        }
    };

    const handleVerification = async (e) => {
        e.preventDefault(); // Prevent form submission
        if (!verificationKey.trim()) {
            setVerificationError(
                language === 'en' 
                    ? 'Please enter a verification key' 
                    : 'Пожалуйста, введите ключ верификации'
            );
            return;
        }

        setIsVerifying(true);
        try {
            // First attempt to verify
            await ApiService.verify(verificationKey.trim());
            
            // Then check if verification was successful
            const accountData = await ApiService.getSelf();
            

            console.log(JSON.stringify(accountData))
            if (accountData.data.verified) {
                setShowVerificationDialog(false);
                navigate('/upload');
            } else {
                setVerificationError(
                    language === 'en' 
                        ? 'Invalid verification key' 
                        : 'Неверный ключ верификации'
                );
            }
        } catch (error) {
            console.error('Verification failed:', error);
            setVerificationError(
                language === 'en'
                    ? 'Verification failed. Please try again.'
                    : 'Ошибка верификации. Пожалуйста, попробуйте снова.'
            );
        } finally {
            setIsVerifying(false);
        }
    };


    const handleSignIn = async () => {
        try {
            setError('');
            const answer = await ApiService.login(username, password);
            localStorage.setItem("token", answer.accessToken);
            localStorage.setItem("refreshToken", answer.refreshToken);
            await checkVerification();
        } catch (errorResponse) {
            setError(handleErrorResponse(errorResponse));
        }
    };

    const handleErrorResponse = (errorResponse) => {
        const errors = {
            en: {
                USERNAME_FORMAT_ERROR: 'Invalid username format.',
                PASSWORD_UNSECURE_ERROR: 'Password is not secure enough.',
                ACCOUNT_EXISTS: 'An account with this email already exists.',
                REGION_DISALLOW_ERROR: 'Sign up is not allowed in your region.',
                EMAIL_FORMAT_ERROR: 'Invalid email format.',
                UNKNOWN_ERROR: 'Check your password',
            },
            ru: {
                USERNAME_FORMAT_ERROR: 'Неверный формат имени пользователя.',
                PASSWORD_UNSECURE_ERROR: 'Пароль недостаточно безопасен.',
                ACCOUNT_EXISTS: 'Аккаунт с этим email уже существует.',
                REGION_DISALLOW_ERROR: 'Регистрация запрещена в вашем регионе.',
                EMAIL_FORMAT_ERROR: 'Неверный формат электронной почты.',
                UNKNOWN_ERROR: 'При авторизации произошла ошибка. Проверьте введёные данные.',
            },
        };

        return errors[language][errorResponse] || errors[language].UNKNOWN_ERROR;
    };

    const handleSignUp = () => {
        window.open('https://ety.one/register?referer=etycloud', '_blank');
    };

    const toggleLanguage = () => {
        setLanguage(language === 'en' ? 'ru' : 'en');
    };

    useEffect(() => {
        const browserLanguage = navigator.language || navigator.userLanguage;
        if (browserLanguage.toLowerCase().includes('ru')) {
            setLanguage('ru');
        }
    }, []);

    const handleKeyPress = async (e) => {
        if (e.key === 'Enter' && showVerificationDialog) {
            await handleVerification(e);
        }
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-header">
                    <EtyLogo className="logo" />
                    <h2>{language === 'en' ? 'Sign in streamline' : 'Вход в streamline'}</h2>
                    <p>{language === 'en' ? 'Sign in to your etyId account' : 'Войдите в свой аккаунт etyID'}</p>
                </div>

                <div className="login-form">
                    {error && <p className="error-message">{error}</p>}
                    <input
                        type="text"
                        placeholder={language === 'en' ? 'Username' : 'Имя пользователя'}
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                    <div className="password-field">
                        <input
                            type={showPassword ? 'text' : 'password'}
                            placeholder={language === 'en' ? 'Password' : 'Пароль'}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>

                    <button className="sign-in-btn" onClick={handleSignIn}>
                        <SignIn /> {language === 'en' ? 'Sign in with etyID' : 'Войти с etyID'}
                    </button>
                    <button className="sign-up-btn" onClick={handleSignUp}>
                        <EtyLogo className='ety-img' /> {language === 'en' ? 'Create etyID Account' : 'Создать аккаунт etyID'}
                    </button>
                </div>
                <button className="language-toggle" onClick={toggleLanguage}>
                    {language === 'en' ? 'Switch to Russian' : 'Переключиться на английский'}
                </button>
            </div>

            {showVerificationDialog && (
                <div className="dialog-overlay" onClick={() => setShowVerificationDialog(false)}>
                    <div className="dialog-content" onClick={e => e.stopPropagation()}>
                        <div className="dialog-header">
                            <h2 className="dialog-title">
                                {language === 'en' ? 'Account Verification Required' : 'Требуется верификация аккаунта'}
                            </h2>
                            <p className="dialog-description">
                                {language === 'en' 
                                    ? 'Please enter your verification key to continue' 
                                    : 'Пожалуйста, введите ваш ключ верификации для продолжения'}
                            </p>
                        </div>
                        <form className="verification-form" onSubmit={handleVerification}>
                            {verificationError && <p className="error-message">{verificationError}</p>}
                            <input
                                type="text"
                                className="verification-input"
                                placeholder={language === 'en' ? 'Verification Key' : 'Ключ верификации'}
                                value={verificationKey}
                                onChange={(e) => setVerificationKey(e.target.value)}
                                onKeyPress={handleKeyPress}
                            />
                            <button 
                                type="submit" 
                                className="verify-btn" 
                                disabled={isVerifying}
                            >
                                {isVerifying 
                                    ? (language === 'en' ? 'Verifying...' : 'Верификация...') 
                                    : (language === 'en' ? 'Verify' : 'Верифицировать')}
                            </button>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default LoginPage;